global.jQuery = require('jquery');
var $ = global.jQuery;
window.$ = $;

const indicatorIcon = document.getElementById('pl_indicator-icon');
const indicatorText_open = document.getElementById(
	'pl_open-text-indicator_open'
);
const indicatorText_closed = document.getElementById(
	'pl_open-text-indicator_closed'
);
const scheduleDiv = document.getElementById('pl_daysSchedule');

function isOpen() {
	const [
		sO,
		sC,
		mO,
		mC,
		tO,
		tC,
		wO,
		wC,
		thO,
		thC,
		fO,
		fC,
		saO,
		saC
	] = scheduleDiv.dataset.daysS.split(',');
	var passedDays = [];
	var passedOpen = [];
	var passedClosed = [];
	if (sO) {
		passedDays.push(0);
		passedOpen.push(sO);
		passedClosed.push(sC);
	}
	if (mO) {
		passedDays.push(1);
		passedOpen.push(mO);
		passedClosed.push(mC);
	}
	if (tO) {
		passedDays.push(2);
		passedOpen.push(tO);
		passedClosed.push(tC);
	}
	if (wO) {
		passedDays.push(3);
		passedOpen.push(wO);
		passedClosed.push(wC);
	}
	if (thO) {
		passedDays.push(4);
		passedOpen.push(thO);
		passedClosed.push(thC);
	}
	if (fO) {
		passedDays.push(5);
		passedOpen.push(fO);
		passedClosed.push(fC);
	}
	if (saO) {
		passedDays.push(6);
		passedOpen.push(saO);
		passedClosed.push(saC);
	}

	const now = new Date(Date.now());
	const currentDay = getDay(now);
	if (passedDays.includes(currentDay)) {
		const currentTime = getMinutes(getTime(now));
		const openTime = getMinutes(passedOpen[passedDays.indexOf(currentDay)]);
		const closedTime = getMinutes(
			passedClosed[passedDays.indexOf(currentDay)]
		);
		return currentTime >= openTime && currentTime < closedTime;
	}
	return false;
}

function getMinutes(timeS) {
	const [time, period] = timeS.split(' ');
	const [hours, minutes] = time.split(':');
	return (
		(parseInt(hours) +
			(period.toUpperCase() === 'PM' && hours !== '12' ? 12 : 0)) *
			60 +
		parseInt(minutes)
	);
}

function getTime(date) {
	let hours = date.getHours();
	const minutes = date.getMinutes();
	const period = hours >= 12 ? 'PM' : 'AM';

	hours = hours % 12;
	hours = hours ? hours : 12;

	return `${hours}:${minutes < 10 ? '0' + minutes : minutes} ${period}`;
}

/**
 * Returns the day of a week from a date Sunday to Saturday => 0-6
 * @param {Date} date
 * @returns {Number} Day
 */
function getDay(date) {
	return date.getDay();
}

$(function() {
	if (indicatorIcon) {
		if (isOpen()) {
			if (!indicatorIcon.classList.contains('pl_indicator-open')) {
				indicatorIcon.classList.add('pl_indicator-open');
				indicatorIcon.classList.remove('pl_indicator-closed');
			}
			if (indicatorText_open.classList.contains('visually-hidden')) {
				indicatorText_open.removeAttribute('aria-hidden');
				indicatorText_open.classList.remove('visually-hidden');

				if (
					!indicatorText_closed.classList.contains('visually-hidden')
				) {
					indicatorText_closed.setAttribute('aria-hidden', 'true');
					indicatorText_closed.classList.add('visually-hidden');
				}
			}
		} else {
			if (!indicatorIcon.classList.contains('pl_indicator-closed')) {
				indicatorIcon.classList.remove('pl_indicator-open');
				indicatorIcon.classList.add('pl_indicator-closed');
			}
			if (indicatorText_closed.classList.contains('visually-hidden')) {
				indicatorText_closed.attributes.removeNamedItem('aria-hidden');
				indicatorText_closed.classList.remove('visually-hidden');

				if (!indicatorText_open.classList.contains('visually-hidden')) {
					indicatorText_open.setAttribute('aria-hidden', 'true');
					indicatorText_open.classList.add('visually-hidden');
				}
			}
		}
	}
});
